import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { CategoriaProgService } from '../../../services/formulacion/categoria-prog.service';
import { GeneralService } from '../../../services/formulacion/general.service';
import { environment } from '../../../../environments/environment';
import { UtilHelper } from '../../../_helpers/util';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-rpt-ejecucion-fus',
  templateUrl: './rpt-ejecucion-fus.component.html',
  styleUrls: [],
  providers: [CategoriaProgService, GeneralService]
})
export class RptEjecucionFusComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;
  scrollByContent = true;
  scrollByThumb = true;
  dataCP: any = [];
  gestiones: any = [];
  gestion: number;
  baseUrl = environment.apiEndpoint;
  rol:number;
  constructor(private _cs: CategoriaProgService, public _gs: GeneralService) {
    //this.getCategoriaProgramatica();
    this.getPoaGestiones();
    let u = JSON.parse(localStorage.getItem('u'));            
    this.rol = u.rol;
  }

  ngOnInit() {
  }
  
  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  refreshDataGrid(e) {
    this.getCategoriaProgramatica();
    this.dataGrid.instance.refresh();
    //this.gestion = e.value;
  }

  getPoaGestiones() {
    this._gs.getPoaGestiones().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.gestiones = result.data; }
        else { this.gestiones = []; }
      });
  }
  getCategoriaProgramatica() {
    this._cs.getCategoriaProgRpt(this.gestion).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataCP = result.data;
        } else {
          this.dataCP = [];
        }
      });
  }

  postAvanceFus(id: number) {
    this._gs.postRptAvanceFus({ id: id }).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          //this.popupVisibleAdd = false;
        }
      });
  }
}
